/* shto-scp-videos: a tap anywhere on a card's picture plays its video in the card, with sound; another tap pauses it and
   one more plays on. Starting a card pauses any other card. Nothing downloads before the tap; the poster shows until the
   video's first frame. Phones get Shopify's 720p copy, wider screens the 1080p one (the 1080p one if a copy is missing).
   A YouTube / Vimeo card opens the platform's player in the card (its own controls pause it).
   A card without a video is a link to its shop page (plain <a>, no script). A drag of the swipe row is not a tap
   (assets/shto-swipe.js swallows that click).
   Progress bar under the row (phones): bar width = the visible part of the row, and it moves with the scroll. */
(function () {
  if (window.ShtoScpVideos) return;
  window.ShtoScpVideos = true;

  function cardsPlaying(except) {
    document.querySelectorAll('.shto-scp-videos video').forEach(function (v) { if (v !== except && !v.paused) v.pause(); });
    document.querySelectorAll('.shto-scp-videos iframe[data-shto-embed-frame]').forEach(function (f) {
      if (f === except || !f.contentWindow) return;
      var msg = f.getAttribute('data-shto-embed-frame') === 'vimeo' ? { method: 'pause' } : { event: 'command', func: 'pauseVideo', args: '' };
      try { f.contentWindow.postMessage(JSON.stringify(msg), '*'); } catch (e) {}
    });
  }

  function label(start, playing) {
    var l = start.getAttribute(playing ? 'data-label-pause' : 'data-label-play');
    if (l) start.setAttribute('aria-label', l);
  }

  function playFile(card, box, start) {
    var video = box.querySelector('video');
    if (!video) {
      video = document.createElement('video');
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.preload = 'auto';
      video.setAttribute('aria-hidden', 'true'); // the card's button is the control
      video.tabIndex = -1;
      var poster = box.querySelector('.shto-scp-videos-poster');
      if (poster) video.poster = poster.currentSrc || poster.src;
      // The file for this screen: wider screens the 1080p copy (data-shto-video); phones under 600px the 720p copy, named
      // in Shopify's HLS list when video.sources doesn't list it. Anything missing or failing: the 1080p copy.
      var full = box.getAttribute('data-shto-video');
      video.addEventListener('error', function () {
        if (video.shtoFellBack || !full || video.getAttribute('src') === full) return;
        video.shtoFellBack = true;
        video.src = full;
        go(video, card, start);
      });
      video.shtoSource = window.matchMedia('(min-width: 600px)').matches ? Promise.resolve(full) : phoneFile(box, full);
      video.addEventListener('play', function () { cardsPlaying(video); card.setAttribute('data-shto-playing', ''); label(start, true); });
      video.addEventListener('playing', function () { card.setAttribute('data-shto-started', ''); });
      video.addEventListener('pause', function () { card.removeAttribute('data-shto-playing'); label(start, false); release(video); });
      video.addEventListener('ended', function () { card.removeAttribute('data-shto-started'); video.currentTime = 0; });
      box.insertBefore(video, box.querySelector('.shto-scp-videos-fade'));
    }
    if (video.shtoPending) {
      // Tapped again while the phone file is still being looked up: don't start.
      card.setAttribute('data-shto-cancel', ''); card.removeAttribute('data-shto-playing'); label(start, false);
      return;
    }
    if (video.paused || video.ended) {
      if (video.shtoSource) {
        // First tap: find the file, then play with sound. load() inside the tap tells iPhones (WebKit) this element was
        // started by the visitor, so the play() that follows the lookup keeps its sound; Chrome allows it after any tap.
        var pick = video.shtoSource; video.shtoSource = null; video.shtoPending = true;
        video.load();
        card.setAttribute('data-shto-playing', ''); label(start, true);
        pick.then(function (src) {
          video.shtoPending = false;
          video.src = src;
          if (card.hasAttribute('data-shto-cancel')) card.removeAttribute('data-shto-cancel');
          else go(video, card, start);
        });
        return;
      }
      go(video, card, start);
    } else video.pause();
  }

  // A paused video that isn't fully downloaded keeps its download open (Chrome only suspends it), and over Shopify's
  // HTTP/3 connection two of them hold the whole connection: the next card's video then never starts. So a card that
  // pauses before its file is complete lets go of the download, and the next tap picks it up from the same second.
  function release(video) {
    var b = video.buffered;
    var whole = b.length && b.start(0) === 0 && b.end(b.length - 1) >= video.duration - 0.5;
    if (video.ended || whole || !video.getAttribute('src')) return;
    video.shtoResume = { src: video.getAttribute('src'), t: video.currentTime };
    video.removeAttribute('src');
    video.load();
  }

  function go(video, card, start) {
    var r = video.shtoResume;
    if (r) {
      video.shtoResume = null;
      video.src = r.src;
      if (r.t > 0) video.addEventListener('loadedmetadata', function at() { video.removeEventListener('loadedmetadata', at); video.currentTime = r.t; });
    }
    video.muted = false;
    var p = video.play();
    if (p && p.catch) p.catch(function () { card.removeAttribute('data-shto-playing'); label(start, false); });
  }

  // The 720p MP4 next to the listed 1080p one. Shopify's HLS list names every copy, e.g.
  // "<id>.HD-720p.1.6Mbps.hls.97043643_.m3u8" -> MP4 "<id>.HD-720p-1.6Mbps-97043643.mp4" in the same folder.
  function phoneFile(box, full) {
    var listed = box.getAttribute('data-shto-video-phone');
    var hls = box.getAttribute('data-shto-video-hls');
    if (listed) return Promise.resolve(listed);
    if (!hls || !window.fetch) return Promise.resolve(full);
    return fetch(hls).then(function (r) { return r.ok ? r.text() : ''; }).then(function (text) {
      var best = null, bestH = 0;
      text.split('\n').forEach(function (line, i, all) {
        var m = /RESOLUTION=\d+x(\d+)/.exec(line);
        if (!m) return;
        var h = +m[1], name = (all[i + 1] || '').trim();
        var parts = /^(.+)\.((?:SD|HD)-\d+p)\.([\d.]+Mbps)\.hls\.(\d+)_?\.m3u8$/.exec(name);
        if (parts && h <= 720 && h > bestH) { bestH = h; best = parts[1] + '.' + parts[2] + '-' + parts[3] + '-' + parts[4] + '.mp4'; }
      });
      return best ? new URL(best, new URL(hls, location.href)).href : full;
    }).catch(function () { return full; });
  }

  function playEmbed(card, box) {
    if (box.querySelector('iframe')) return;
    var type = box.getAttribute('data-shto-embed-type');
    var f = document.createElement('iframe');
    f.src = box.getAttribute('data-shto-embed');
    f.setAttribute('data-shto-embed-frame', type);
    f.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture; encrypted-media');
    f.setAttribute('allowfullscreen', '');
    var t = card.querySelector('.shto-scp-videos-title');
    f.title = (t ? t.textContent.trim() + ' ' : '') + 'video';
    cardsPlaying(f);
    box.appendChild(f);
    card.setAttribute('data-shto-playing', '');
    card.setAttribute('data-shto-started', '');
    f.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var start = e.target.closest && e.target.closest('button.shto-scp-videos-start');
    if (!start) return;
    var box = start.closest('.shto-scp-videos-media');
    var card = start.closest('.shto-scp-videos-card');
    if (!box || !card) return;
    e.preventDefault();
    if (box.hasAttribute('data-shto-video')) playFile(card, box, start);
    else if (box.hasAttribute('data-shto-embed')) playEmbed(card, box);
  });

  function initProgress(root) {
    var row = root.querySelector('.shto-scp-videos-rail');
    var track = root.querySelector('.shto-scp-videos-progress');
    if (!row || !track || row.shtoProgress) return;
    row.shtoProgress = true;
    var ticking = false;
    function update() {
      ticking = false;
      var total = row.scrollWidth, seen = row.clientWidth, w = track.clientWidth;
      if (!total || !w) return;
      var part = Math.min(1, seen / total);
      track.style.setProperty('--scp-videos-bar', (part * w).toFixed(2) + 'px');
      track.style.setProperty('--scp-videos-bar-x', ((row.scrollLeft / total) * w).toFixed(2) + 'px');
    }
    function ask() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    row.addEventListener('scroll', ask, { passive: true });
    window.addEventListener('resize', ask);
    update();
  }

  function initAll(scope) { (scope || document).querySelectorAll('.shto-scp-videos').forEach(initProgress); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
